import { clsx, type ClassValue } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

/**
 * Extend tailwind-merge so it recognizes our custom Linear type scale
 * (`text-micro` … `text-title1`) and motion tokens as their correct groups.
 * Without this, twMerge treats `text-small` as a color utility and kicks
 * out a legitimate `text-white`, producing invisible button labels.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        { text: ["micro", "mini", "small", "regular", "large", "title1", "title2", "title3"] },
      ],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
